import React from "react";
import { cn } from "@/lib/utils";

export const SectionHeading = ({ eyebrow, title, subtitle, align = "center", className }) => (
  <div
    className={cn(
      "max-w-2xl mb-10 sm:mb-14",
      align === "center" ? "mx-auto text-center" : "text-left",
      className
    )}
  >
    {eyebrow && (
      <span className={cn("section-eyebrow", align === "center" ? "justify-center" : "justify-start")}>
        <span className="h-px w-6 bg-primary/60" />
        {eyebrow}
        <span className="h-px w-6 bg-primary/60" />
      </span>
    )}
    <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-foreground leading-tight mt-4">
      {title}
    </h2>
    {subtitle && (
      <p className="mt-4 text-sm sm:text-base text-muted-foreground leading-relaxed">{subtitle}</p>
    )}
  </div>
);
